/* istanbul ignore file */
export const INLINE_NOTIFICATIONS = {
    SITE_TEMPLATE_WARNING: (siteAlias: string): string => `The ${siteAlias} template fields' values will overwrite matching fields in this ${siteAlias} — continue if that’s expected.`,
    SITE_TEMPLATE_BULK_WARNING: (siteAlias: string, sitesAlias: string): string => `When bulk updating existing ${sitesAlias.toLocaleLowerCase()}, the selected ${siteAlias} template will overwrite data on matching fields — continue if that’s expected.`
};
